<div class="intro-background" [ngStyle]="{ 'background-image': 'url(' + backgroundImageUrl + ')'}">
  <div class="product-detail-offer-body">
    <div class="intro-small">
      <h3 class="product-detail-offer-title" [translate]="titleKey"></h3>
      <p class="intro-text" [innerHTML]="descriptionKey | translate">
      </p>
    </div>
    <div class="product-offers">
      <div class="play-sports-grid">
        <div *ngFor="let sport of sportsArray; let i = index" class="item">
          <app-play-sports-grid-item [omapiId]="omapiId" [name]="sport?.name" [active]="sport?.active" [x]="i" [y]="0"
                                     (emitBannerInfo)="changeBannerInfo($event)"></app-play-sports-grid-item>
        </div>
      </div>
      <div class="play-sports-offer-banner">
        <div class="play-sports-offer-banner-image margin-top-20">
          <img class="play-sports-offer-banner-image" src="{{bannerUrl}}">
        </div>
      </div>
    </div>
  </div>
</div>
